import _ from "lodash";
import { fetchApi } from "../../utils";

export const createContactMessage = async (values) => {
  const data = {
    name: _.get(values, 'name'),
    email: _.get(values, 'email'),
    phone: _.get(values, 'phone'),
    message: _.get(values, 'message'),
  }
  const result = await fetchApi('contacts', 'POST', JSON.stringify(data));
  return result;
}


// WEBPACK FOOTER //
// ./src/services/page/contactmessage.js